import React from 'react'

import { COLORS } from '../../constants/general.constants'

interface Props {
  onClick?: () => void
  className?: string
  dataTestId?: string
  width?: number
  height?: number
  viewBox?: string
  id?: string | number
}
/**
 * Icon Info SVG
 */
export const IconInfo: React.FC<Props> = ({
  className = 'menu__icon',
  dataTestId = 'icon-info',
  height = 21,
  viewBox = '0 0 21 21',
  width = 21,
  id,
  onClick,
}): JSX.Element => (
  <svg
    data-testid={dataTestId}
    {...{
      height,
      id: String(id),
      viewBox,
      width,
      className,
      onClick,
    }}
  >
    <g
      id='Cabinet-styleguide'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-393.000000, -3942.000000)'
    >
      <g id='Group-23' transform='translate(30.000000, 3856.000000)'>
        <g id='Group-33' transform='translate(363.000000, 29.000000)'>
          <g id='Group-32'>
            <g id='i-hover' transform='translate(0.000000, 57.000000)'>
              <path
                // eslint-disable-next-line max-len
                d='M9.5,19 C4.25329488,19 0,14.7467051 0,9.5 C0,4.25329488 4.25329488,0 9.5,0 C14.7467051,0 19,4.25329488 19,9.5 C19,14.7467051 14.7467051,19 9.5,19 Z'
                id='html/icon'
                fill='#71747A'
                className={`${className} ${className}-circle`}
              />
              <path
                // eslint-disable-next-line max-len
                d='M11.5258789,13.0922852 L11.3862305,13.6635742 C10.9672831,13.8286141 10.6329765,13.954508 10.3833008,14.0412598 C10.1336251,14.1280115 9.84375165,14.1713867 9.51367188,14.1713867 C9.00585684,14.1713867 8.61124815,14.0476087 8.32983398,13.8000488 C8.04841982,13.552489 7.90771484,13.2382832 7.90771484,12.8574219 C7.90771484,12.7093092 7.91829417,12.5580249 7.93945312,12.4035645 C7.96061208,12.249104 7.99446591,12.0745452 8.04101562,11.8798828 L8.56152344,10.0263672 C8.60807315,9.84863192 8.64721664,9.68042072 8.67895508,9.52172852 C8.71069352,9.36303632 8.7265625,9.21809961 8.7265625,9.08691406 C8.7265625,8.84993371 8.67789762,8.6848963 8.58056641,8.59179688 C8.48323519,8.49869745 8.29703914,8.45214844 8.02197266,8.45214844 C7.88655531,8.45214844 7.7479662,8.47330708 7.60620117,8.515625 C7.46443614,8.55794292 7.34277395,8.59814434 7.24121094,8.63623047 L7.38085938,8.06494141 C7.72363453,7.92529227 8.05159349,7.80574594 8.36474609,7.70629883 C8.6778987,7.60685172 8.9741197,7.55712891 9.25341797,7.55712891 C9.75700122,7.55712891 10.1452623,7.6787911 10.4182129,7.92211914 C10.6911635,8.16544718 10.8276367,8.48176889 10.8276367,8.87109375 C10.8276367,8.9514978 10.8181153,9.0932607 10.7990723,9.29638672 C10.7800292,9.49951273 10.7451174,9.68570879 10.6943359,9.85498047 L10.1738281,11.7021484 C10.1315102,11.8502612 10.0934246,12.0195303 10.0595703,12.2099609 C10.025716,12.4003916 10.0087891,12.5442703 10.0087891,12.6416016 C10.0087891,12.8870455 10.0638015,13.0541988 10.1738281,13.1430664 C10.2838547,13.231934 10.4742825,13.2763672 10.7451172,13.2763672 C10.8720709,13.2763672 11.0159497,13.2541506 11.1767578,13.2097168 C11.3375659,13.165283 11.4539384,13.1261395 11.5258789,13.0922852 Z M11.6591797,5.34179688 C11.6591797,5.66341307 11.5375175,5.93741749 11.2941895,6.16381836 C11.0508614,6.39021923 10.7578142,6.50341797 10.4150391,6.50341797 C10.0722639,6.50341797 9.77815878,6.39021923 9.53271484,6.16381836 C9.28727091,5.93741749 9.16455078,5.66341307 9.16455078,5.34179688 C9.16455078,5.02018068 9.28727091,4.74511833 9.53271484,4.51660156 C9.77815878,4.28808479 10.0722639,4.17382812 10.4150391,4.17382812 C10.7578142,4.17382812 11.0508614,4.28808479 11.2941895,4.51660156 C11.5375175,4.74511833 11.6591797,5.02018068 11.6591797,5.34179688 Z'
                id='і'
                fill={COLORS.eloWhite}
                className={`${className} ${className}-text`}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

IconInfo.displayName = 'IconInfo'
